import { render, staticRenderFns } from "./SampleSection.vue?vue&type=template&id=c1826e48&scoped=true&"
import script from "./SampleSection.vue?vue&type=script&lang=js&"
export * from "./SampleSection.vue?vue&type=script&lang=js&"
import style0 from "./SampleSection.vue?vue&type=style&index=0&id=c1826e48&lang=scss&scoped=true&"
import style1 from "./SampleSection.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1826e48",
  null
  
)

export default component.exports